import { PRODUCTION, DEVELOPMENT, GLOBAL_API_DEV_URL } from "./const";
import { isEmpty } from "lodash";

export function globalBaseUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const API_URL = !!import.meta.env.VITE_API_UMS_URL && import.meta.env.VITE_API_UMS_URL !== "" ? import.meta.env.VITE_API_UMS_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return GLOBAL_API_DEV_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return GLOBAL_API_DEV_URL;
    }
  } else {
    return GLOBAL_API_DEV_URL;
  }
}

export const globalGetApiUrl = (path) => {
  return `${globalBaseUrl()}/${path}`;
};
